import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import safeEval from '@packages/safe-eval';
import { withStyles } from '@material-ui/core/styles';
import MaterialTableHead from '../../components/MaterialTableV2/MaterialTableHead';
import AddBulkItemsTableRow from './AddBulkItemsTableRow';
import { PAGE, ROWS_PER_PAGE, SIZE } from '../../constants/constants';
import { isArrayValidAndNotEmpty } from '../../constants/CommonUtil';
import { getStringFromObject } from '../../constants/lodashUtils';
import { isObjectValidAndNotEmpty } from '../../constants/nullCheckUtils';
import { NumberOf } from '../../constants/numberUtils';

const styles = () => ({
    root: {
        width: '100%',
    },
    table: {},
});

class AddBulkItemsTable extends React.Component {
    getDiscountForProduct = (product) => {
        const { autoDiscountConfig } = this.props;
        const productType = getStringFromObject('type', product);
        if (
            isObjectValidAndNotEmpty(autoDiscountConfig) &&
                    isArrayValidAndNotEmpty(autoDiscountConfig[productType])
        ) {
            const matchingCondition = autoDiscountConfig[productType].find((aCondition) => {
                const {
                    fieldToCheck,
                    operation,
                    value,
                    ignoreProducts,
                    multipleOperations,
                    operationList,
                } = aCondition;
                if (isArrayValidAndNotEmpty(ignoreProducts) && ignoreProducts.includes(product.uuid)) {
                    return false;
                }
                let evaluationString = '';
                const productValForField = getStringFromObject(fieldToCheck, product);
                if (multipleOperations) {
                    if (!isArrayValidAndNotEmpty(operationList)) return false;
                    const operationsStrings = operationList.map(
                        anOperation => `${productValForField}${anOperation.operation}${anOperation.value}`,
                    );
                    evaluationString = operationsStrings.join('&&');
                } else {
                    evaluationString = `${productValForField}${operation}${value}`;
                }
                try {
                    return safeEval(evaluationString);
                } catch (e) {
                    console.error('error evaluating expression', evaluationString);
                }
                return false;
            });
            console.log('matching condition', matchingCondition);
            if (isObjectValidAndNotEmpty(matchingCondition)) {
                return matchingCondition.discount;
            }
        }
        return 0;
    }

    handleSelectAllClick = (event) => {
        const { schema, onSelect, data } = this.props;
        if (schema.hideCheckBoxIcon) {
            return;
        }

        if (event.target.checked) {
            data.forEach((product) => {
                const baseProduct = {
                    ...product,
                    discount: this.getDiscountForProduct(product),
                    discount2: NumberOf(product.purchaseDiscount),
                    purchaseQuantity: 1,
                };
                onSelect(baseProduct, false);
            });
        } else {
            data.forEach((product) => {
                const baseProduct = {
                    ...product,
                    discount: '--',
                    discount2: '--',
                    purchaseQuantity: '--',
                };
                onSelect(baseProduct, true);
            });
        }
    };

    handleClick = (event, id, data) => {
        console.log('asd-9asids0ad', id, data);
        const {
            onSelect,
        } = this.props;


        if (event.target.checked) {
            const baseProduct = {
                ...data,
                discount: this.getDiscountForProduct(data),
                discount2: NumberOf(data.purchaseDiscount),
                purchaseQuantity: 1,
            };
            onSelect(baseProduct, false);
        } else {
            const baseProduct = {
                ...data,
                discount: '--',
                discount2: '--',
                purchaseQuantity: '--',
            };
            onSelect(baseProduct, true);
        }
    };

    handleChangePage = (event, page) => {
        const { onPageChange, size } = this.props;
        onPageChange(page, size);
    };

    handleChangeRowsPerPage = (event) => {
        const { page } = this.props;
        this.props.onPageChange(page, event.target.value);
    };

    updateData = (index, updatedData) => {
        this.props.handleUpdateSelectedProduct(updatedData, false);
    };

    render() {
        const {
            classes,
            schema,
            uniqueKey,
            page,
            size,
            totalElements,
            selectedProducts,
            data,
        } = this.props;

        let headerRowStyle = { background: '#fafafa' };
        if (schema.headerRowStyle) {
            headerRowStyle = { ...schema.headerRowStyle };
        }
        const headerColStyle = { color: '#000', fontSize: '14px' };
        const emptyRows = size - Math.min(size, (data.length - page) * size);
        const tableCells = schema.tableCells || [];
        const paginationCompProps = {
            rowsPerPageOptions: ROWS_PER_PAGE,
            component: 'div',
            count: totalElements,
            rowsPerPage: size,
            page,
            backIconButtonProps: {
                'aria-label': 'Previous Page',
            },
            nextIconButtonProps: {
                'aria-label': 'Next Page',
            },
            onChangePage: this.handleChangePage,
            onChangeRowsPerPage: this.handleChangeRowsPerPage,
            first: false,
            last: false,
        };
        const tableName = schema.name;
        return (
            <Paper className={classes.root}>
                <div className={classes.tableWrapper}>
                    <Table
                        className={classes.table}
                        style={{ overflowY: 'none' }}
                        aria-labelledby="tableTitle"
                    >
                        <MaterialTableHead
                            numSelected={data.filter(item => selectedProducts[item.uuid]).length}
                            order
                            orderBy
                            onSelectAllClick={this.handleSelectAllClick}
                            rowCount={data.length}
                            tableCells={tableCells}
                            hideCheckBoxIcon={schema.hideCheckBoxIcon || false}
                            headerRowStyle={headerRowStyle || {}}
                            headerColStyle={headerColStyle || {}}
                            isExpandable={false}
                            tableName={tableName}
                        />
                        <TableBody style={{ cursor: 'pointer' }}>
                            {
                                data.map((n, index) => {
                                    const isSelected = isObjectValidAndNotEmpty(selectedProducts[n.uuid]);
                                    return (
                                        <AddBulkItemsTableRow
                                            uniqueKey={uniqueKey}
                                            schema={schema}
                                            key={getStringFromObject(uniqueKey, n) || uuidv4()}
                                            tableCells={schema.tableCells}
                                            index={index}
                                            rowStyle={schema.rowStyle}
                                            onCheckBoxClick={this.handleClick}
                                            data={selectedProducts[n.uuid] || n}
                                            hideCheckBoxIcon={schema.hideCheckBoxIcon}
                                            isSelected={isSelected}
                                            tableName={tableName}
                                            updateData={this.updateData}
                                        />
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow id={`${schema.id}-empty-row`} style={{ height: 49 }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
                {
                    <TablePagination
                        {...paginationCompProps}
                    />
                }
            </Paper>
        );
    }
}

AddBulkItemsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    schema: PropTypes.object,
    onPageChange: PropTypes.func,
    onSelect: PropTypes.func,
    data: PropTypes.array,
    onRowClick: PropTypes.func,
    uniqueKey: PropTypes.string,
    page: PropTypes.number,
    size: PropTypes.number,
    totalElements: PropTypes.number,
    handleUpdateSelectedProduct: PropTypes.func,
    selectedProducts: PropTypes.array,
    autoDiscountConfig: PropTypes.object,
};

AddBulkItemsTable.defaultProps = {
    schema: {},
    onPageChange: () => {},
    onSelect: () => {},
    data: [],
    page: PAGE,
    size: SIZE,
    totalElements: 0,
    uniqueKey: 'uuid',
    onRowClick: () => {},
    handleUpdateSelectedProduct: () => {},
    selectedProducts: [],
    autoDiscountConfig: {},
};

export default withStyles(styles)(AddBulkItemsTable);
